var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggler",class:{'on': _vm.value},on:{"click":_vm.toggle}},[_c('div',{staticClass:"handle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }